import { render } from "./gpoSlider.vue?vue&type=template&id=03628c90&scoped=true"
import script from "./gpoSlider.vue?vue&type=script&lang=js"
export * from "./gpoSlider.vue?vue&type=script&lang=js"

import "./gpoSlider.vue?vue&type=style&index=0&id=03628c90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03628c90"]])

export default __exports__